import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { PowerSchedule } from '@/features/plants/schemas/schedule-plant.schema.ts';

export type GetSchedulePlantsResponse = PowerSchedule[];

export const useGetSchedulesPlantQuery = (
  { plantId, enabled }: { plantId?: string; enabled?: boolean } = {
    plantId: undefined,
    enabled: true,
  }
) => {
  return useQuery({
    queryKey: ['plants', plantId, 'schedules'],
    queryFn: async () => {
      const { data } = await client.get<{ body: GetSchedulePlantsResponse }>(
        `/plants/${plantId}/schedules`
      );
      return data.body;
    },
    enabled,
  });
};
